import { CSSProperties, ReactNode } from 'react';
import { ICellRendererParams } from 'ag-grid-community';

const containerStyle: CSSProperties = {
    height: '70%',
    overflowX: 'hidden',
    overflowY: 'auto',
    padding: '0 0',
    display: 'grid',
};

const paragraphStyle: CSSProperties = {
    lineHeight: 1.2,
    wordBreak: 'break-word',
    margin: 0,
    marginBottom: '3px',
};

interface GridCellLargeTextProps extends ICellRendererParams {
    cellHeight?: string;
}

//note: don't use this where you could have array/list data - it will blow up
// - use GridCellList instead
export const GridCellLargeTextView = ({ value, cellHeight }: GridCellLargeTextProps): ReactNode => {
    const cellStyle: CSSProperties = cellHeight ? { ...containerStyle, height: cellHeight } : { ...containerStyle };
    return (
        <div style={cellStyle} className="scrolly" title={value?.toString()}>
            {value
                ?.toString()
                ?.split('\n')
                ?.map((paragraph, i) => (
                    <p key={i} style={paragraphStyle}>
                        {paragraph}
                    </p>
                ))}
        </div>
    );
};
